import { CheckCircle } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import heroImage from "@/assets/real-estate-closings.jpg";

const Closings = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Residential & Commercial Real Estate Closings</h2>
          <p className="text-lg text-muted-foreground">
            Full-service closing coordination for residential and commercial property transactions in Houston, Texas. We handle all aspects of closing to ensure smooth property transfers, from document preparation to final recording.
          </p>
        </div>
      </div>
    </section>
  );
  return <GenericPracticePage title="Real Estate Closings" subtitle="Professional Closing Services" icon={<CheckCircle className="h-16 w-16 text-accent" />} mainContent={mainContent} heroImage={heroImage} />;
};
export default Closings;